import script from "./TransferReferralTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferReferralTable.vue?vue&type=script&setup=true&lang=ts"

import "./TransferReferralTable.vue?vue&type=style&index=0&id=33b0795b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b0795b"]])

export default __exports__